import type { TitleComponentSpec } from "../../Processing/types";

// ── State ──

export interface TitleFormState {
  title: string;
}

// ── Actions ──

export type TitleAction = { type: "SET_TITLE"; title: string };

// ── Reducer ──

export function titleReducer(state: TitleFormState, action: TitleAction): TitleFormState {
  switch (action.type) {
    case "SET_TITLE":
      return { ...state, title: action.title };
    default:
      return state;
  }
}

// ── Factories ──

export function createInitialState(): TitleFormState {
  return { title: "" };
}

export function hydrateFromSpec(spec: TitleComponentSpec): TitleFormState {
  return { title: spec.display.title };
}

export function formStateToSpec(state: TitleFormState): TitleComponentSpec | null {
  const title = state.title || "Untitled";
  return {
    type: "title",
    display: {
      title,
    },
  };
}
